 <select #langSelect (change)="translate.use(langSelect.value)">
    <option  *ngFor="let lang of translate.getLangs()" [value]="lang"  [attr.selected]="lang === translate.currentLang ? '' : null">
        <span class="flag-icon flag-icon-{{lang}}">{{lang}}</span>
    </option>
  </select> 
 